// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Xe","itemsContainer":"Ye"};